import type { DataFeature, DataLayer } from '../shared/data-layer.js';
import { runImportWorker } from './import-worker-client.js';

/** Resolve a single record for an editor; never attach page/view batches to map state. */
export async function layerForFeature(layer: DataLayer, id: string): Promise<DataLayer> {
  if (!layer.dataset) return layer;
  const feature = await runImportWorker('datasetFeature', { ref: layer.dataset, id });
  if (!feature) throw new Error('The feature is no longer available.');
  return { ...layer, features: [feature] };
}

export async function updateDatasetLayer(layer: DataLayer, changes: DataFeature[], deleted: string[] = [], color?: string): Promise<DataLayer> {
  if (!layer.dataset) return layer;
  const result = await runImportWorker('datasetEdit', { ref: layer.dataset, changes, deleted, color });
  const updated = { ...layer, ...result, features: [], saved: false };
  if (changes.length || deleted.length) delete updated.bbox;
  return updated;
}
